/** /legal/process-settings — the Head of Legal's own door to the Legal Diary process (legal_head or can_configure_system). */
import { Scale } from "lucide-react";
import LegalDiarySettings from "@/pages/settings/LegalDiarySettings";

export default function LegalProcessSettingsPage() {
  return (
    <div className="p-4 md:p-6 space-y-4" data-testid="legal-process-settings-page">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-md bg-red-50 border border-red-200 flex items-center justify-center shrink-0"><Scale className="w-4 h-4 text-red-700" /></div>
        <div>
          <h1 className="text-lg font-semibold text-slate-900">Legal process settings</h1>
          <p className="text-xs text-muted-foreground">Stages, timers, gates, thresholds and templates for the legal diary. Edit a draft, review the changes, publish with a reason — nothing changes until you publish.</p>
        </div>
      </div>
      <LegalDiarySettings />
    </div>
  );
}
